<template>
  <el-form  >
    <el-form-item>
    <quill-editor v-model="description"
				ref="noteEditor"
				:options="editorOptions">
			</quill-editor>
    </el-form-item>
    <el-row>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-upload  ref="upload" class="upload-section" :data="getData()" :on-change="handleChange" :on-success="addNoteSucceeded" :headers="getHeaders()" :action="postAction" :multiple="false" :auto-upload="false">
          <el-button type="default" class="add-attachment-button" :disabled="btnUploadDisabled || note != null" icon="el-icon-document">{{$t('clients.addAttachment')}}</el-button>
          <div slot="tip" class="el-upload__tip">files with a size less than 1024kb</div>
        </el-upload>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
        <el-button  class="add-note-button" type="primary" @click="addNote()" :disabled="btnAddNoteDisabled">
          <span>{{$t('notes.save')}}</span>
        </el-button>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import axios from "axios"
import { EventBus } from '@/core/event-bus'



export default {
	name: 'QuickNote',
	props: {
    customerId : String,
    contactId : String,
    noteId: {
      type: Number,
      default: null,
    },
    note: Object,
  },
	components : {

	},
	data() {
		return {
      description : "",
      file : null,
      btnUploadDisabled : false,
      btnAddNoteDisabled : false,
      placeholder : 'Saisir la note',
      editorOptions: {
				theme: 'snow',
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike'],
						[{ 'header': [1, 2, 3, false] }],
					]
				}
			}
		}
	},
  watch: {
    noteId: function(val) {
      if (this.note == null) {
        this.reset();
      } else {
        this.initEdition();
      }
    }
  },
	computed : {
    editionMode (){
      return this.note != null;
    },
    postAction(){
      let id = this.contactId||this.customerId;
      let path = this.contactId?"/contacts/":"/customers/";
      return process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API"+path+id+"/notes";
    }
  },
	methods : {
    reset (){
      this.description = null;
      this.file = null;
      this.btnUploadDisabled = false;
      this.btnAddNoteDisabled = false;
    },
    initEdition (){
      this.description = this.note.description;
    },
    getHeaders(){
      var headers = {};
      headers.Authorization = localStorage.getItem('access-token')
      return headers;
    },
    getData(){
      var data = {};
      data.description = this.description;
      return data;
    },
    addNote(){
      EventBus.$emit('adding-note');
      this.btnUploadDisabled=true;
      this.btnAddNoteDisabled=true;

      if(this.file!=null){
        this.$refs.upload.submit();
      }else{
        let postData = {};
        postData.description = this.description;

        let id = this.contactId||this.customerId;
        let path = this.contactId?"/contacts/":"/customers/";

        if (this.editionMode){
          axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/notes/"+this.noteId, postData)
            .then(response=>{
              this.editNoteSucceeded(response.data);
            }).catch(err=>{
              console.log(err)
            })
        } else {
          axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API"+path+id+"/notes", postData)
            .then(response=>{
              this.addNoteSucceeded(response.data);
            }).catch(err=>{
              console.log(err)
            })
        }


      }

    },
    validUpload(file){
      // console.log("validation");
      // console.log(file);
    },
    editNoteSucceeded(response){
      this.btnUploadDisabled=false;
      this.btnAddNoteDisabled=false;
      EventBus.$emit('note-edited', response);
      this.$emit('close');
      this.description = "";
      this.$refs.upload.clearFiles();
      this.file = null;
      this.$notify({
    		title: "Modification d'une note",
    		message: 'La note a été modifiée avec succès!',
    		type: 'success'
        });
    },
    addNoteSucceeded(response,file){
      this.btnUploadDisabled=false;
      this.btnAddNoteDisabled=false;
      EventBus.$emit('note-added', response);
      this.$emit('close');
      this.description = "";
      this.$refs.upload.clearFiles();
      this.file = null;
      this.$notify({
    		title: 'Nouvelle note',
    		message: 'La note a été enregistrée avec succès!',
    		type: 'success'
        });
    },
    handleChange(file){
      //console.log("Change file : ", file);
      if(file.status=="success"){
        this.file = null;
      }else{
        this.file= file;
      }
    }

  },
  mounted(){
    if (this.note != null) {
      this.initEdition();
    }
  }
}
</script>
<style lang="scss">
@import '../assets/scss/_variables';

.el-form{
  margin:20px;margin-right:40px;
}

.add-note-button{
  float:right;
}
.quill-editor {
  .ql-toolbar.ql-snow {
    //border: none;
    //background: lighten($background-color, 2%);
    //border-bottom: 1px solid $background-color;
  }
  .ql-container.ql-snow {
    //border: none;
    height:150px;
  }
}

@media (max-width: 768px) {
  .el-form{
    margin:0px;
  }
  .add-note-button{
    position:relative;
    float:none;
    width:100%;
    margin-top:20px;
  }
  .el-upload{
    width:100%;
  }
  .add-attachment-button{
    position:relative;
    float:none;
    width:100%;
  }
}

</style>
